module.exports = __webpack_public_path__ + "static/media/pause-sign.d8ba455e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/pause-sign.svg
// module id = 390
// module chunks = 0